<template>
  <v-layout wrap>
    <v-flex xs12 sm6 v-if="!isNotShowJson">
      <template>
        <intent-group
          :isNotAltText="true"
          :isNotRatio="true"
          v-if="messages && messages.length > 0"
          :maxLength="1"
          :isBroadCast="true"
          v-model="messages"
          :hasAlternative="false"
          :isWelcome="true"
          :availableBubbles="['text', 'button', 'image', 'generic']"
          :isHasPrefill="false"
          :isAdsPreview='true'
        ></intent-group>

        <div class="mb-3 caption primary--text" v-if="hasGeneric">
          *
          {{ $t('condition_ads1') }}
        </div>
        <div class="mb-3 caption primary--text">
          *
          {{ $t('condition_ads') }}
        </div>

        <div class="form-control" :class="{ 'has-error': errorTag['replies'].length > 0 }">
          <tags
            v-model="reply"
            :tags="replies"
            @tags-changed="addReplies('replies', $event)"
            @before-adding-tag="checkQuickReply('replies', $event)"
            style="margin-bottom: 5px"
            :btnText="$t('Add choice')"
          ></tags>
        </div>
        <div class="form-control has-error">
          <template v-for="(error, errorKey) in errorTag">
            <span :key="errorKey" class="text-error" v-if="error.length > 0">
              <template v-if="error.includes('overmaxlength')">{{
                $t('Message cannot be longer than 20 alphabets')
              }}</template>
              <template v-else-if="error.includes('overtagmax')">{{
                $t('choices_5_items')
              }}</template>
              <template v-else-if="error.includes('duplicate')">{{
                $t('Duplicate Choice')
              }}</template>
            </span>
          </template>
        </div>
      </template>
    </v-flex>
    <v-flex xs12 :sm6="!isNotShowJson" style="text-align: -webkit-center;">
      <div
        style="width: 275px; padding: 90px 0px 0px; background: rgb(164, 167, 172); border-radius: 8px; border: 1px solid;"
        class="mt-3"
      >
        <div style="background: #FFFFFF; border-radius: 20px 20px 0px 0px;">
          <div
            style="padding-top: 28px;text-align: left;font-size: 10px; margin-left: 30px;float: left"
          >
            <div style="float: left">
              <img
                v-if="selectedBot"
                :src="selectedBot.pagelogo || imageProfile"
                alt
                style=" margin-left: 10px;width: 28px; height: 28px;border: 1px solid #eee;border-radius: 50%; float: left;margin-right: 5px;"
              />
            </div>
            <div style="float: left">
              <div class="text-truncate" style="color: black;font-weight: 600;max-width: 100px">
                {{ selectedBot.pagename | truncate(13) }}
              </div>
              <div class="small">{{ $t('Typically replies instantly') }}</div>
            </div>
          </div>
          <div class="clearfix"></div>
          <div style="min-height: 230px; margin-top: 5px;" v-if="messages && messages.length > 0">
            <div style="overflow-y: auto; max-height: 280px; overflow-x: hidden" class="left-align">
              <message-viewer
                :ratioHorizontal="true"
                v-model="messages"
                :size="'small'"
                :showProfile="true"
              ></message-viewer>
              <div class="clearfix"></div>
            </div>
          </div>
          <div style="position:relative;margin-top: 15px;">
            <template>
              <small class="mt-2"
                >{{ $t('when_you_reply') }}
                {{ selectedBot.pagename | truncate(13) }}
                {{ $t('will_be_able_public_clicked') }}</small
              >
              <div
                class="mt-2"
                style="margin: auto;width: 100%;text-align:center; bottom: 0;overflow-x: auto; overflow-y: hidden;height: 50px;white-space: nowrap;"
              >
                <ul style="margin: auto;padding: 0">
                  <li
                    v-for="(reply, index) in replies"
                    :key="'reply_' + index"
                    style="list-style-type: none;display:inline;padding: 5px 10px;margin-right: 5px;border-radius: 20px;color:#000; box-shadow: 3px 2px 4px #bcadadfa;"
                  >
                    {{ reply.text }}
                  </li>
                </ul>
              </div>
            </template>
          </div>

          <div style="border-top: 1px solid #eee;margin-bottom: -7px;">
            <img
              src="/static/img/assets/facebook_ui/iOS Composer Default.png"
              style="width: 274px; margin-bottom: 2px;"
              alt
            />
          </div>
        </div>
      </div>
      <div class="text-xs-center mt-2" v-if="!isNotShowJson">
        <v-btn style="text-transform: none;" color="primary" outline @click="dialogJson = true">
          View as JSON
        </v-btn>
      </div>

      <v-dialog v-if="dialogJson" v-model="dialogJson" width="500">
        <v-card>
          <v-card-text>
            <div class="text-xs-right">
              <v-btn fab small flat @click="dialogJson = false">
                <v-icon>close</v-icon>
              </v-btn>
            </div>
            <div class="mt-2">
              <codemirror
                ref="cmCode"
                v-if="jsonMessages"
                v-model="jsonMessages"
                :options="cmOptions"
              ></codemirror>
              <div class="text-xs-center">
                <v-btn
                  small
                  flat
                  v-clipboard:copy="jsonMessages"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onCopyError"
                  color="primary"
                >
                  <v-icon class="mr-2">content_copy</v-icon> {{ $t('copy_json') }}
                </v-btn>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-snackbar v-model="showCopy" :timeout="6000" color="green" :top="true"
        >{{ $t('Copied') }}!</v-snackbar
      >
    </v-flex>
  </v-layout>
</template>

<script>
import IntentGroup from '@/components/view/intent/IntentGroup'
import MessageViewer from '@/components/elements/MessageViewer'
import Tags from '@/components/elements/Tags'
import { codemirror } from 'vue-codemirror'
import { mapGetters } from 'vuex'
export default {
  props: {
    value: {
      default: null
    },
    isOnlyJson: {
      default: false
    },
    quickReply: {
      default: null
    },
    isNotShowJson: {
      default: false
    }
  },
  data() {
    return {
      reply: '',
      errorTag: {
        replies: []
      },
      showCopy: false,
      dialogJson: false,
      messages: this.value,
      cmOptions: {
        mode: {
          name: 'javascript',
          json: true
        },
        lineNumbers: true,
        showCursorWhenSelecting: true,
        matchBrackets: true,
        styleSelectedText: true,
        readOnly: true,
        theme: 'base16-light'
      }
    }
  },
  components: {
    IntentGroup,
    MessageViewer,
    codemirror,
    Tags
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    hasGeneric() {
      const vm = this
      if (vm.messages && vm.messages[0]) {
        return vm.messages[0].some(el => {
          return ['generic'].includes(el.type)
        })
      } else {
        return false
      }
    },
    replies: {
      get() {
        const vm = this
        if (vm.quickReply && vm.quickReply !== '') {
          var quick_replies = []
          quick_replies = vm.quickReply.split(',')
          var result = []
          try {
            result = quick_replies.map(val => {
              return { text: val }
            })
          } catch (error) {}
          return result
        } else {
          return []
        }
      },
      set(value) {
        const vm = this
        var result = []
        try {
          result = value.map(el => {
            return el.text
          })
        } catch (error) {}
        vm.$emit('update:quickReply', result.join(','))
      }
    },
    imageProfile() {
      var http = new XMLHttpRequest()
      var image_url =
        'https://graph.facebook.com/' +
        this.selectedBot.pageid +
        '/picture?width=300&height=300&SameSite=None'
      http.open('HEAD', image_url, false)
      http.send()
      if (http.status != 404 && http.status != 400) {
        return image_url
      } else {
        return '/static/img/assets/livechat/profile.png'
      }
    },

    jsonMessages() {
      const vm = this
      let setMessages = JSON.stringify(vm.messages[0])
      setMessages = JSON.parse(setMessages)
      setMessages.map(item => {
        item.template_type = item.type
        item.elements = item.data
        delete item.type
        delete item.data
        delete item.altText
        if (item.buttons && item.buttons.length > 0) {
          item = vm.replaceShop(item.buttons)
        }
        if (item.elements && item.elements.length > 0) {
          item.elements.map(item => {
            item = vm.replaceShop(item.buttons)
          })
        }
      })
      let replies = JSON.stringify(vm.replies)
      replies = JSON.parse(replies)
      replies.map(item => {
        item.title = item.text
        item.payload = item.text
        item.content_type = 'text'
        delete item.text
      })
      let json = {}
      if (setMessages[0] && setMessages[0].template_type === 'text') {
        json.message = { text: setMessages[0].text }
      } else if (
        setMessages[0] &&
        (setMessages[0].template_type === 'button' || setMessages[0].template_type === 'generic')
      ) {
        delete setMessages[0].custom_type
        json.message = {
          attachment: {
            type: 'template',
            payload: setMessages[0]
          }
        }
      } else if (setMessages[0] && setMessages[0].template_type === 'image') {
        json.message = {
          attachment: {
            type: 'image',
            payload: { url: setMessages[0].image_url }
          }
        }
      }

      if (json.message && replies.length > 0) {
        json.message['quick_replies'] = replies
      }
      return JSON.stringify(json, null, 4)
    }
  },
  methods: {
    replaceShop(arrayData) {
      const vm = this
      if (arrayData && arrayData.length > 0) {
        arrayData.map(item => {
          if (item && item.type !== 'postback') {
            item.url = item.url
              ? item.url.includes('{shopurl}')
                ? item.url.replace(
                    '{shopurl}',
                    `https://shopv2.zwiz.app/ecommerce/${vm.selectedBot.pageid}?`
                  )
                : item.url.replace(
                    '{salepage}',
                    `https://shopv2.zwiz.app/salepage/${vm.selectedBot.pageid}?`
                  )
              : ''
          }
        })
      }
      return arrayData
    },
    addReplies: function(type, newTags) {
      const vm = this
      vm.replies = newTags
    },
    checkQuickReply(type, obj) {
      const vm = this
      vm.errorTag[type] = []
      if (obj.tag.text == '') {
      } else if (obj.tag.text.length > 20) {
        vm.errorTag[type].push('overmaxlength')
        obj.error()
      } else if (obj.type == 'add' && type == 'replies' && vm.replies.length >= 5) {
        vm.errorTag[type].push('overtagmax')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        vm.errorTag[type].push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    onCopy() {
      const vm = this
      vm.showCopy = true
    },
    onCopyError() {}
  }
}
</script>

<style lang="scss" scoped>
.CodeMirror pre {
  white-space: pre-wrap;
  word-break: break-all;
  word-wrap: break-word;
}

.CodeMirror pre {
  height: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/AdsSimulator/AdsSimulatorPreview.vue